/**
 * @generated SignedSource<<c8fcb29e5f5ddaea27078c87bb3ede43>>
 * @relayHash faa6751d2beda1e9d376d2dba7109e4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bca7bbcea8e85dd63cfad877d18eff0331641a2258108aac38359be8e8d2ecda

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type JiraProjectOptions = {
  projectType?: JiraProjectType | null | undefined;
};
export type getProjectProps133BadPatternQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  jql: string;
  jqlTerm: string;
  projectOptions?: JiraProjectOptions | null | undefined;
  searchString: string;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type getProjectProps133BadPatternQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly project?: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getProjectProps133BadPatternQuery = {
  response: getProjectProps133BadPatternQuery$data;
  variables: getProjectProps133BadPatternQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlTerm"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectOptions"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  },
  {
    "kind": "Variable",
    "name": "jqlTerm",
    "variableName": "jqlTerm"
  },
  {
    "kind": "Variable",
    "name": "projectOptions",
    "variableName": "projectOptions"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v11 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v13 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v14 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getProjectProps133BadPatternQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v8/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v9/*: any*/),
                  "concreteType": "JiraJqlFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": false,
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "concreteType": "JiraJqlFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v12/*: any*/),
                            (v13/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraProject",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    (v14/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraJqlProjectFieldValue"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "getProjectProps133BadPatternQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlProjectFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bca7bbcea8e85dd63cfad877d18eff0331641a2258108aac38359be8e8d2ecda",
    "metadata": {},
    "name": "getProjectProps133BadPatternQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "93481e3f2e65611aa5773536a784454c";

export default node;
